import Store from '@ember-data/store';
import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import FundModel from 'donor-elf-web/models/fund';
import MailchimpAccountModel, {
  type MailchimpAudience,
} from 'donor-elf-web/models/mailchimp-account';
import MailchimpFundSyncModel from 'donor-elf-web/models/mailchimp-fund-sync';
import FundsService from 'donor-elf-web/services/funds-service';
import NavbarSettingsService from 'donor-elf-web/services/navbar-settings';

export class MailchimpSyncRouteModel {
  constructor(
    mailchimpAccounts: MailchimpAccountModel[],
    mailchimpFundSyncInfos: MailchimpFundSyncInfo[],
  ) {
    this.mailchimpAccounts = mailchimpAccounts;
    this.mailchimpFundSyncInfos = mailchimpFundSyncInfos;
  }
  mailchimpAccounts: MailchimpAccountModel[];
  @tracked mailchimpFundSyncInfos: MailchimpFundSyncInfo[];
}

export interface MailchimpFundSyncInfo {
  mailchimpFundSync: MailchimpFundSyncModel;
  fund?: FundModel;
  mailchimpAudience?: MailchimpAudience;
  mailchimpAccount?: MailchimpAccountModel;
}

export default class MailchimpSyncRoute extends Route {
  @service declare fundsService: FundsService;
  @service declare navbarSettings: NavbarSettingsService;
  @service declare router: RouterService;
  @service declare store: Store;

  beforeModel() {
    this.navbarSettings.title = 'MailChimp Sync';
  }

  async model(): Promise<MailchimpSyncRouteModel> {
    let mailchimpAccounts = (
      await this.store.query('mailchimp-account', {})
    ).slice();
    let mailchimpFundSyncInfos: MailchimpFundSyncInfo[] = [];
    let mailchimpFundSyncs = mailchimpAccounts
      .map((ma) => ma.mailchimpFundSyncs.slice())
      .flat();
    if (mailchimpFundSyncs.length > 0) {
      let fundIds = mailchimpFundSyncs.map((mfs) => mfs.fundId) as string[];
      let funds = await this.fundsService.getFunds(fundIds);
      mailchimpFundSyncInfos = mailchimpFundSyncs.map((mailchimpFundSync) => {
        let mailchimpAccount = mailchimpAccounts.find(
          (x) => x.id == mailchimpFundSync.mailchimpAccountId,
        )!;
        return {
          mailchimpFundSync,
          fund: funds.find((x) => x.id == mailchimpFundSync.fundId)!,
          mailchimpAudience: mailchimpAccount.audiences.find(
            (x) => x.id === mailchimpFundSync.audienceId,
          )!,
          mailchimpAccount,
        };
      });
    }
    return new MailchimpSyncRouteModel(
      mailchimpAccounts,
      mailchimpFundSyncInfos,
    );
  }

  redirect(model: MailchimpSyncRouteModel, transition: any) {
    if (model.mailchimpAccounts.length > 0) {
      if (!transition.to?.name.endsWith('mailchimp-sync.connected')) {
        this.router.transitionTo('funds.fund.more.mailchimp-sync.connected');
      }
    } else if (!transition.to?.name.endsWith('mailchimp-sync.not-connected')) {
      this.router.transitionTo('funds.fund.more.mailchimp-sync.not-connected');
    }
  }
}
